import { FORMAT_C3_YEAR_DATE } from '@cube3/common/model/schema/resources/metadata-field';
import moment from 'moment';
import { FieldType } from '../types/GenericFormTypes';

const emptyArray = [];

const waterfallSelectParser = (val) => {
  return val
    ? { value: { [val.input.level1]: val.input.level2 || emptyArray } }
    : undefined;
};
const numberParser = (val) => (val === '' ? undefined : Number(val));
const stringParser = (val) => {
  if (val !== undefined) {
    const s = String(val);

    if (s.trim() === '' || s === '') {
      return '';
    } else {
      return s;
    }
  }
};
const identityParser = (val) => {
  return val
}

export const dateParser = (val) =>
  val && moment(val).endOf('day').startOf('second').toISOString();

export const yearParser = (val) =>
  val && moment(val).utc(true).startOf('year').toISOString();

export const multiSelectParser = (val = emptyArray) =>
  val.map((v) => (typeof v === 'string' ? v : v.id));

export const recipientsParser = (val = emptyArray) =>
  val.map((v) => (typeof v === 'string' ? v : v.email_address));

export const checkboxParser = (val = false) => {
  return val
}
export const checkboxMultipleParser = (val = emptyArray) => {
  return val
}


/** NOTE: FieldArray type fields don't support parse */
export const makeParser = (fieldType: FieldType, schema?) => {
  const type = fieldType;

  switch (type) {
    case 'checkbox':
      if (schema && JSON.parse(schema)?.type === 'boolean') {
        return checkboxParser

      } else {
        return checkboxMultipleParser
      }
    case 'date':
      if (schema && JSON.parse(schema)?.format === FORMAT_C3_YEAR_DATE) {
        return yearParser;
      }
      return dateParser;
    case 'number':
      return numberParser;
    case 'string':
    case 'email':
    case 'textarea':
      return stringParser;
    case 'waterfall_select':
      return waterfallSelectParser;
    case 'multiselect':
      return multiSelectParser;
    case 'recipients':
      return recipientsParser;
    default:
      return identityParser;
  }
};
